import { render, staticRenderFns } from "./RespondentGuide.vue?vue&type=template&id=8ca5fcd6"
import script from "./RespondentGuide.vue?vue&type=script&lang=js"
export * from "./RespondentGuide.vue?vue&type=script&lang=js"
import style0 from "./RespondentGuide.vue?vue&type=style&index=0&id=8ca5fcd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports